import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import tr from './locales/tr';
import en from './locales/en';
import de from './locales/de';

/* Desteklenen diller ve locale nesneleri */
export const LOCALES = { tr, en, de };
export const LANG_LABELS = { tr: 'TR', en: 'EN', de: 'DE' };
const LANG_ORDER = ['tr', 'en', 'de'];
const STORAGE_KEY = 'atunears.lang';

const LangContext = createContext({
  lang: 'tr',
  locale: tr,
  setLang: () => {},
  cycleLang: () => {},
});

function getInitialLang() {
  try {
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (stored && LOCALES[stored]) return stored;
  } catch {
    /* localStorage erişimi engellenmiş olabilir */
  }
  // Tarayıcı diline göre fallback — tam eşleşme veya ön ek eşleşmesi
  try {
    const browserLang = navigator.language?.split('-')[0];
    if (LOCALES[browserLang]) return browserLang;
  } catch {
    /* navigator erişimi yoksa sessizce geç */
  }
  return 'tr';
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* Yazma hatasını yoksay */
    }
  }, [lang]);

  const setLang = useCallback((code) => {
    if (LOCALES[code]) setLangState(code);
  }, []);

  // Sıradaki dile geç: tr → en → de → tr
  const cycleLang = useCallback(() => {
    setLangState((current) => {
      const idx = LANG_ORDER.indexOf(current);
      return LANG_ORDER[(idx + 1) % LANG_ORDER.length];
    });
  }, []);

  const value = useMemo(
    () => ({ lang, locale: LOCALES[lang], setLang, cycleLang }),
    [lang, setLang, cycleLang],
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

/* Bağlam hook'u */
export function useLang() {
  return useContext(LangContext);
}
